import { registerView } from '../viewRegistry';
import { getCanonicalSafeArea } from '../safeArea';

// Canonical dopeOS phosphor green
const PHOSPHOR = '#39FF14';
// const BASE_BLUE removed: only PHOSPHOR green is used

// ViewBox dimensions for each stage
const VIEWBOX = {
  stage1: { width: 1280, height: 417.43 },
  stage2: { width: 1280, height: 323.84 }
};

// SVG-derived paths for Stage 1 (four tile-like rectangles)
const STAGE1_PATHS = [
  new Path2D('M289.34,120.78c-3.1-1.52-7.13-1.52-15.18-1.52h-131.57c-8.05,0-12.08,0-15.18-1.52-2.97-1.46-5.36-3.86-6.82-6.83-1.52-3.1-1.52-7.14-1.52-15.21V23.55c0-8.07,0-12.1-1.52-15.21-1.45-2.97-3.85-5.37-6.82-6.83-3.1-1.52-7.13-1.52-15.18-1.52H23.52c-8.06,0-12.08,0-15.18,1.52-2.97,1.46-5.36,3.86-6.82,6.83-1.52,3.1-1.52,7.14-1.52,15.21v370.32c0,8.07,0,12.1,1.52,15.21,1.45,2.97,3.85,5.37,6.82,6.83,3.1,1.52,7.13,1.52,15.18,1.52h250.64c8.05,0,12.08,0,15.18-1.52,2.97-1.46,5.37-3.86,6.82-6.83,1.52-3.1,1.52-7.14,1.52-15.21v-251.05c0-8.07,0-12.1-1.52-15.21-1.45-2.97-3.85-5.37-6.82-6.83Z'),
  new Path2D('M616.78,120.78c-3.1-1.52-7.12-1.52-15.18-1.52h-250.64c-8.06,0-12.08,0-15.18,1.52-2.97,1.46-5.36,3.86-6.82,6.83-1.52,3.1-1.52,7.14-1.52,15.21v251.05c0,8.07,0,12.1,1.52,15.21,1.45,2.97,3.85,5.37,6.82,6.83,3.1,1.52,7.13,1.52,15.18,1.52h250.64c8.06,0,12.08,0,15.18-1.52,2.97-1.46,5.37-3.86,6.82-6.83,1.52-3.1,1.52-7.14,1.52-15.21v-251.05c0-8.07,0-12.1-1.52-15.21-1.45-2.97-3.85-5.37-6.82-6.83Z'),
  new Path2D('M944.22,120.78c-3.1-1.52-7.13-1.52-15.18-1.52h-250.64c-8.06,0-12.08,0-15.18,1.52-2.97,1.46-5.36,3.86-6.82,6.83-1.52,3.1-1.52,7.14-1.52,15.21v251.05c0,8.07,0,12.1,1.52,15.21,1.46,2.97,3.85,5.37,6.82,6.83,3.1,1.52,7.12,1.52,15.18,1.52h250.64c8.06,0,12.08,0,15.18-1.52,2.96-1.46,5.36-3.86,6.82-6.83,1.52-3.1,1.52-7.14,1.52-15.21v-251.05c0-8.07,0-12.1-1.52-15.21-1.45-2.97-3.85-5.37-6.82-6.83Z'),
  new Path2D('M1278.48,127.61c-1.46-2.97-3.85-5.37-6.82-6.83-3.1-1.52-7.12-1.52-15.18-1.52h-250.64c-8.06,0-12.08,0-15.18,1.52-2.97,1.46-5.36,3.86-6.82,6.83-1.52,3.1-1.52,7.14-1.52,15.21v251.05c0,8.07,0,12.1,1.52,15.21,1.45,2.97,3.85,5.37,6.82,6.83,3.1,1.52,7.13,1.52,15.18,1.52h250.64c8.06,0,12.08,0,15.18-1.52,2.97-1.46,5.36-3.86,6.82-6.83,1.52-3.1,1.52-7.14,1.52-15.21v-251.05c0-8.07,0-12.1-1.52-15.21Z')
];

// SVG-derived paths for Stage 2 (letters "base" and square)
const STAGE2_LETTERS_PATH = new Path2D('M447.23,323.58c-25.22,0-49.54-9.22-63.87-33.54h-8.32v26.62h-57.34V0h57.34v115.2h8.32c14.72-25.22,42.24-34.94,67.07-34.94,61.95,0,103.81,49.54,103.81,119.3s-45.95,123.9-107.01,123.9v.13ZM434.82,272.26c35.33,0,60.54-28.93,60.54-70.27s-25.73-70.27-60.54-70.27-59.65,27.52-59.65,70.27,25.22,70.27,59.65,70.27ZM660.22,323.58c-44.03,0-79.87-26.62-79.87-70.27s39.42-67.97,87.17-72.96l67.46-6.91v-12.8c0-19.71-16.13-33.54-44.54-33.54s-42.75,11.9-47.74,29.82h-55.04c5.5-43.65,41.73-76.67,102.78-76.67s97.79,28.42,97.79,83.97v112c0,14.21,1.41,33.92,2.3,39.42v.9h-55.04c-.51-7.81-.51-15.1-.51-22.91h-8.32c-14.21,22.91-39.04,29.82-66.56,29.82l.13.13ZM675.84,280.45c37.63,0,59.26-28.42,59.26-57.34v-11.52l-50.56,6.02c-31.23,3.71-46.34,12.8-46.34,33.02s15.62,29.82,37.63,29.82ZM926.08,323.58c-57.86,0-99.2-28.93-105.6-74.37h56.45c6.4,20.22,27.52,28.93,49.54,28.93s40.83-9.6,40.83-26.62-17.41-21.63-41.34-25.73l-24.32-4.1c-45.95-7.81-74.37-27.14-74.37-68.35s39.42-72.96,94.08-72.96,88.58,24.83,98.18,67.97h-55.04c-6.4-17.02-23.42-23.81-42.75-23.81s-38.53,10.11-38.53,24.32,11.9,19.33,36.74,23.42l24.32,4.1c44.54,7.3,78.46,25.73,78.46,70.27s-40.45,77.18-96.9,77.18l.26-.26ZM1166.59,323.58c-70.66,0-117.5-48.26-117.5-122.11s49.54-121.22,118.02-121.22,112.9,53.25,112.9,123.52v10.11h-174.85c2.82,38.14,29.44,60.54,61.57,60.54s42.75-9.22,50.56-25.22h58.75c-11.9,43.14-54.66,74.37-109.31,74.37h-.13ZM1223.94,175.87c-4.61-30.72-28.93-48.64-57.34-48.64s-55.04,17.41-60.54,48.64h118.02-.13Z');
const STAGE2_SQUARE_PATH = new Path2D('M13.82,316.8c-9.22,0-13.82-4.61-13.82-13.82V100.99c0-9.22,4.61-13.82,13.82-13.82h201.98c9.22,0,13.82,4.61,13.82,13.82v201.98c0,9.22-4.61,13.82-13.82,13.82H13.82Z');

// Animation constants
const STAGE2_SCALE = 1; // Fixed scale – no pulse or dynamic scaling
const STAGGER = 0.42; // delay between tile reveals (scaled for 5 s loop)
// Timeline (seconds)
const REVEAL_END = 1.25; // scaled
const HOLD_DURATION = 0.83; // scaled
const COLLAPSE_START = REVEAL_END + HOLD_DURATION; // 2.5
const COLLAPSE_DURATION = 0.42; // scaled
const MORPH_START = COLLAPSE_START + COLLAPSE_DURATION; // 3.0
const MORPH_DURATION = 0.42; // scaled
const LETTER_INTERVAL = 0.21;
const LETTER_B_START = MORPH_START + MORPH_DURATION; // 2.92
const LETTER_A_START = LETTER_B_START + LETTER_INTERVAL; // ~3.13
const LETTER_S_START = LETTER_A_START + LETTER_INTERVAL; // ~3.33
const LETTER_E_START = LETTER_S_START + LETTER_INTERVAL; // ~3.54
const FADE_OUT_START = 4.58; // scaled
const LOOP_DURATION = 5.0;

function ease(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function lerp(a, b, t) {
  return a + (b - a) * t;
}

// Unused color interpolation function retained for reference
/*
function lerpColor(start, end, t) {
  const r1 = parseInt(start.substr(1,2),16), g1 = parseInt(start.substr(3,2),16), b1 = parseInt(start.substr(5,2),16);
  const r2 = parseInt(end.substr(1,2),16), g2 = parseInt(end.substr(3,2),16), b2 = parseInt(end.substr(5,2),16);
  const r = Math.round(r1 + (r2 - r1) * t).toString(16).padStart(2,'0');
  const g = Math.round(g1 + (g2 - g1) * t).toString(16).padStart(2,'0');
  const b = Math.round(b1 + (b2 - b1) * t).toString(16).padStart(2,'0');
  return `#${r}${g}${b}`;
}
*/

export function renderBaseLogo(ctx, t, w, h) {
  const { left: x, top: y, width, height } = getCanonicalSafeArea({ w, h });
  ctx.save();
  ctx.beginPath();
  ctx.rect(x, y, width, height);
  ctx.clip();

  // Compute time in loop
  const dt = t % LOOP_DURATION;

  // Use fixed viewBox height so Stage-1 tiles remain locked vertically
  const vbHeight = VIEWBOX.stage1.height;
  const vbWidth = VIEWBOX.stage1.width; // Width is same
  const scale = Math.min(width / vbWidth, height / vbHeight) * 0.7; // reduce size by 30%
  ctx.translate(x + (width - vbWidth * scale) / 2, y + (height - vbHeight * scale) / 2);
  ctx.scale(scale, scale);

  // Stage 1 reveal & collapse
  const TILE_APPEAR_TIMES = [0, STAGGER, STAGGER * 2, STAGGER * 3];
  if (dt < COLLAPSE_START) {
    // Reveal each tile one by one
    STAGE1_PATHS.forEach((path, i) => {
      if (dt >= TILE_APPEAR_TIMES[i]) {
        ctx.fillStyle = PHOSPHOR;
        ctx.fill(path);
      }
    });
  } else if (dt < MORPH_START) {
    // Collapse tiles 2–4 into tile 1
    const p = ease((dt - COLLAPSE_START) / COLLAPSE_DURATION);
    // Absolute X origins from the path definitions
    const origXs = [289.34, 616.78, 944.22, 1278.48];
    const firstX = origXs[0];
    STAGE1_PATHS.forEach((path, i) => {
    ctx.save();
      if (i === 0) {
        // Always draw the first tile in place
        ctx.fillStyle = PHOSPHOR;
        ctx.fill(path);
      } else {
        // Translate other tiles toward the first
        const dx = firstX - origXs[i];
        ctx.translate(dx * p, 0);
      ctx.fillStyle = PHOSPHOR;
        ctx.fill(path);
      }
      ctx.restore();
    });
  } else if (dt < MORPH_START + MORPH_DURATION) {
    // Morph Stage-1 first tile into Stage-2 square (cross-fade)
    const p = ease((dt - MORPH_START) / MORPH_DURATION); // 0→1

    // Morph: cross-fade + shrinking circular mask centered on Stage-2 square
    const pRaw = (dt - MORPH_START) / MORPH_DURATION; // 0→1
    const blurMax = 4.2; // px
    const blur = blurMax * Math.sin(Math.PI * pRaw);

    // Stage-2 square geometry
    const SQ_LEFT = 13.82;
    const SQ_TOP  = 100.99;
    const SQ_SIZE = 201.98; // width & height
    const CX = SQ_LEFT + SQ_SIZE / 2;
    const CY = SQ_TOP  + SQ_SIZE / 2;

    // Circle radius shrinks from covering whole tile-1 to 0
    const TILE1_BR_X = 289.34 + 250.64; // bottom-right corner
    const TILE1_BR_Y = 120.78 + 251.05;
    const maxR = Math.hypot(TILE1_BR_X - CX, TILE1_BR_Y - CY); // enough to cover tile
    const radius = lerp(maxR, 0, pRaw);

    // --- Stage-1 tile masked ---
    ctx.save();
    ctx.filter = `blur(${blur}px)`;
    ctx.beginPath();
    ctx.arc(CX, CY, Math.max(radius, 0.1), 0, Math.PI * 2);
    ctx.clip();
    ctx.globalAlpha = 1 - pRaw;
    ctx.fillStyle = PHOSPHOR;
    ctx.fill(STAGE1_PATHS[0]);
    ctx.restore();

    // --- Stage-2 square fade-in ---
    ctx.save();
    ctx.filter = `blur(${blur}px)`;
    ctx.globalAlpha = pRaw;
    ctx.fillStyle = PHOSPHOR;
    ctx.fill(STAGE2_SQUARE_PATH);
    ctx.restore();
  } else if (dt < FADE_OUT_START) {
    // Hold the square and reveal BASE letters from left to right
    ctx.save();
    ctx.fillStyle = PHOSPHOR;
    ctx.fill(STAGE2_SQUARE_PATH); // square is always visible

    const totalLetterReveal = (LETTER_E_START + LETTER_INTERVAL) - LETTER_B_START; // 2.0s
    const revealProgress = Math.min(1, (dt - LETTER_B_START) / totalLetterReveal);
    const clipWidth = vbWidth * revealProgress;

    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, clipWidth, vbHeight);
    ctx.clip();
    ctx.fill(STAGE2_LETTERS_PATH);
    ctx.restore();

    ctx.restore();
  } else {
    // Fade out to reset the loop
    const p = 1 - (dt - FADE_OUT_START) / (LOOP_DURATION - FADE_OUT_START); // 0→1 fade
    ctx.save();
    ctx.globalAlpha = p;
    ctx.fillStyle = PHOSPHOR;
    ctx.fill(STAGE2_SQUARE_PATH);
    ctx.fill(STAGE2_LETTERS_PATH);
    ctx.restore();
  }

  ctx.restore();
}

registerView('base_logo', renderBaseLogo);